"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ModalPaymentErrorContent = ({ modalStateErrorDescription }) => {
    const termsContentText = `Ops, aconteceu algum problema com seu pagamento, por favor verifique os dados de Hóspede e Pagamento.`;
    return (react_1.default.createElement("div", { className: "terms-modal-body" }, modalStateErrorDescription ? (react_1.default.createElement("div", { className: "terms-data-container" }, modalStateErrorDescription)) : (react_1.default.createElement("div", { className: "terms-data-container" }, termsContentText))));
};
exports.default = ModalPaymentErrorContent;
